export default __webpack_public_path__ + "static/media/cpplogo.8eb73fde.jpg";